import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useCallback, useState } from "react";
import Select from "react-select";
import { useEffect } from "react";

const DialogTurnOnSensor = ({
  open,
  onClose,
  listSensorSampleRate = [],
  callbackTurnOnSensor,
  //   callbackCheckCalibration,
  //   callbackCheckAllCalibration,
  callbackCheckAllTurnOnSensor,
  callbackCheckTurnOnSensor,
  callbackSelectSampleRate,
}) => {
  //   const [checkedCalibrationAll, setCheckedCalibrationAll] = useState(false);
  const [checkedTurnOnSensorAll, setCheckedTurnOnSensorAll] = useState(true);

  useEffect(() => {
    // console.log("sensor sample rate", listSensorSampleRate);
    if (listSensorSampleRate?.length > 0) {
      let stateAllTurnOn = true;
      //   let stateAllCalibration = true;
      for (let i = 0; i < listSensorSampleRate?.length; i++) {
        const sensors = listSensorSampleRate[i][1];
        for (let j = 0; j < sensors.length; j++) {
          const { isCalibration, isRecording, isTurn, group, numberSensor } =
            sensors[j];
          if (!isTurn) {
            stateAllTurnOn = false;
          }
          //   if (!isCalibration) {
          //     stateAllCalibration = false;
          //   }
          //   console.log(group, numberSensor, isCalibration);
        }
      }
      setCheckedTurnOnSensorAll(stateAllTurnOn);
      //   setCheckedCalibrationAll(stateAllCalibration);
    }
  }, [listSensorSampleRate]);

  const filterSettingSampleRateOptions = useCallback((sensor) => {
    let isDisabled = false;
    let options = sampleRateOptions;
    if (
      sensor.includes("Accelerometer") ||
      sensor === "Strain" ||
      sensor === "Gyroscope"
    ) {
      options = [...options.filter((item) => item.value !== 1)];
    } else if (
      sensor === "LVDT" ||
      sensor === "Temperature" ||
      sensor === "Temperature & Humidity" ||
      sensor.includes("Anemometer") ||
      sensor.includes("Tension")
    ) {
      options = [options.find((item) => item.value === 1)];
      isDisabled = true;
    }
    return { options, isDisabled };
  }, []);

  const header = useCallback(() => {
    return (
      <div className="d-flex flex-row justify-content-between gap-2">
        {/* <FormControlLabel
          control={
            <Checkbox
              checked={checkedCalibrationAll}
              className="m-0 p-0 mr-2 align-items-start"
              onChange={(ev) => {
                callbackCheckAllCalibration(ev.target.checked);
                setCheckedCalibrationAll(ev.target.checked);
              }}
            />
          }
          label="Kalibrasi Semua"
          className="m-0 p-0 align-items-start"
        /> */}
        <FormControlLabel
          control={
            <Checkbox
              checked={checkedTurnOnSensorAll}
              className="m-0 p-0 mr-2 align-items-start"
              onChange={(ev) => {
                callbackCheckAllTurnOnSensor(ev.target.checked);
                setCheckedTurnOnSensorAll(ev.target.checked);
              }}
            />
          }
          label="Aktifkan Semua"
          className="m-0 p-0 align-items-start"
        />
      </div>
    );
  }, [callbackCheckAllTurnOnSensor, checkedTurnOnSensorAll]);

  const body = useCallback(() => {
    if (listSensorSampleRate?.length === 0)
      return (
        <Typography variant="subtitle" className="text-muted">
          Tidak ada sensor terdeteksi
        </Typography>
      );

    return listSensorSampleRate?.map((item) => {
      if (!item[0]?.toString()?.includes("Power Distribution")) {
        return (
          <div className="d-flex flex-column mb-3" key={item[0]}>
            <div className="d-flex flex-row align-items-start justify-content-between w-100">
              <Typography
                variant="h6"
                fontSize="1.4em"
                style={{ fontWeight: 500, flex: 1 }}
              >
                {item[0]}
              </Typography>
              <Typography
                variant="h6"
                fontSize="1.2em"
                style={{ fontWeight: 500 }}
              >
                Sample Rate
              </Typography>
            </div>
            <div className="d-flex flex-column">
              {item[1]?.map((sensor, index) => {
                return (
                  <div
                    className="d-flex flex-column"
                    key={`${sensor?.createdAt ?? index}`}
                  >
                    <div className="d-flex flex-row align-items-center justify-content-between">
                      <Typography
                        variant="subtitle"
                        style={{
                          fontSize: "1.2em",
                          flex: 2,
                        }}
                      >
                        {item[0]} {sensor?.numberSensor}
                      </Typography>

                      <div
                        className="d-flex flex-row justify-content-between align-items-center"
                        style={{
                          flex: 2,
                          gap: "4em",
                        }}
                      >
                        {/* <FormControlLabel
                          control={
                            <Checkbox
                              disabled={sensor?.isRecording}
                              checked={
                                sensor?.isRecording
                                  ? true
                                  : checkedCalibrationAll
                                  ? true
                                  : sensor?.isCalibration
                              }
                              className="m-0 p-0 mr-2 align-items-start"
                              onChange={(ev) => {
                                callbackCheckCalibration(
                                  item[0],
                                  index,
                                  ev.target.checked
                                );
                                // if (!ev.target.checked)
                                //   setCheckedCalibrationAll(false);
                              }}
                            />
                          }
                          label="Kalibrasi"
                          className="m-0 p-0 align-items-start"
                        /> */}

                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={sensor.isRecording}
                              checked={
                                sensor.isRecording
                                  ? true
                                  : checkedTurnOnSensorAll
                                  ? true
                                  : sensor?.isTurn
                              }
                              className="m-0 p-0 mr-2 align-items-start"
                              onChange={(ev) => {
                                callbackCheckTurnOnSensor(
                                  item[0],
                                  index,
                                  ev.target.checked
                                );
                                // if (!ev.target.checked)
                                //   setCheckedTurnOnSensorAll(false);
                              }}
                            />
                          }
                          label="Aktif"
                          className="m-0 p-0 align-items-start"
                        />

                        <span style={{ flex: 1 }}>
                          <Select
                            options={
                              filterSettingSampleRateOptions(item[0]).options
                            }
                            value={
                              sampleRateOptions.find(
                                (find) => find?.value === sensor?.sampleRate
                              ) || {
                                value: sensor?.sampleRate,
                                label: sensor?.sampleRate,
                              }
                            }
                            placeholder="sample rate"
                            isDisabled={
                              sensor?.sampleRate !== 0
                                ? filterSettingSampleRateOptions(item[0])
                                    .isDisabled
                                : false
                            }
                            onChange={(ev) => {
                              callbackSelectSampleRate(
                                item[0],
                                index,
                                ev.value
                              );
                            }}
                          />
                        </span>
                      </div>
                    </div>
                    <span className="my-2">
                      <Divider variant="fullWidth" />
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      }
    });
  }, [
    callbackCheckTurnOnSensor,
    callbackSelectSampleRate,
    checkedTurnOnSensorAll,
    filterSettingSampleRateOptions,
    listSensorSampleRate,
  ]);

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={() => onClose()}
      aria-describedby="dialog"
      fullWidth
      maxWidth={"md"}
    >
      <div
        className="d-flex w-100 justify-content-between align-items-start"
        style={{
          padding: "2em 1.6em 0.5em 1.6em",
        }}
      >
        <div className="d-flex justify-content-start align-items-start gap-3">
          <Typography variant="h5">Pengaturan Sample Rate</Typography>
        </div>
        <Button
          onClick={() => onClose()}
          // icon={ICONS.CLOSE({ style: { fontSize: "1.5em" } })}
          // background="transparent"
          className="border-lightgray bg-transparent"
          label="X"
        />
      </div>
      <div className="w-100 d-flex px-3 my-3">{header()}</div>
      <DialogContent>{body()}</DialogContent>
      <DialogActions
        style={{
          padding: "1em 2em 2.5em 2em",
        }}
      >
        <Button
          onClick={() => onClose()}
          className="btn bg-light text-dark shadow-sm"
        >
          Batal
        </Button>

        <Button
          onClick={() => callbackTurnOnSensor()}
          className="btn bg-success shadow-sm"
        >
          Simpan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogTurnOnSensor;

const sampleRateOptions = [
  {
    value: 1,
    label: 1,
  },
  {
    value: 50,
    label: 50,
  },
  {
    value: 100,
    label: 100,
  },
  {
    value: 150,
    label: 150,
  },
];
